<div
  class="relative p-[10px] border-2 border-solid border-transparent transition-border duration-300 ease-in-out hover:!border-2 hover:!border-solid hover:!border-primary max-w-[100%] !w-[400px] cursor-pointer authenticity-container"
  [id]="'pagemodule' + content.id" [ngStyle]="{
    backgroundColor: styles.colors['other']['background'],
  }" [ngClass]="{
    '!border-2 !border-solid !border-primary': isSelectedModule,
  }">
  <div class="text-center mb-4 !w-100">
    <!-- Show icon and text only when authenticated -->
    @if (isAuthenticated$()) {
    @if (items[0].value.url) {
    <div class="flex w-100 items-center justify-center authentication-icon-container">
      <div [attr.style]="buildStyle('image', items[0].styles?.icon)" class="p-3 rounded-full mb-3">
        <img [src]="items[0].value.url" class="w-[40px] h-[40px] object-contain" />
      </div>
    </div>
    }
    <div
      class="text-center text-md font-bold mb-2 authentication-message-success p-[10px] border-2 border-solid mt-[5px] mb-[5px] bg-transparent"
      [attr.style]="buildStyle('text', items[1].styles?.text)">
      {{ items[1].value.text }}
    </div>
    }

    <!-- Show tag not found message when tag is not found -->
    @if (isTagNotFound$()) {
    <div class="text-center">
      <div class="flex w-100 items-center justify-center authentication-icon-container">
        <div class="p-3 rounded-full mb-3 bg-red-100">
          <svg class="w-[40px] h-[40px] text-red-600" fill="currentColor" viewBox="0 0 20 20">
            <path fill-rule="evenodd"
              d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z"
              clip-rule="evenodd"></path>
          </svg>
        </div>
      </div>
      <div class="authentication-message-failure p-[10px] border-2 border-solid mt-[5px] mb-[5px] bg-transparent"
        [attr.style]="buildStyle('text', items[1].styles?.text)">
        <span class="text-red-600 font-semibold">The product is suspicious and the scan does not meet our scan
          rules</span>
      </div>
    </div>
    }
    <!-- Show scanner button when NOT authenticated OR tag not found -->
    @if (!isAuthenticated$() || isTagNotFound$()) {
    <div>
      <div (click)="onLinkClick($event)"
        class="h-text-center p-[10px] border-2 border-solid mt-[5px] mb-[5px] bg-transparent scanner-button"
        [attr.style]="buildStyle('button', items[2].styles?.button)">
        <a [ngStyle]="{
              color: 'inherit',
              fontSize: 'inherit',
              fontWeight: 'inherit',
              fontFamily: 'inherit',
              backgroundColor: 'inherit',
              textAlign: 'inherit',
            }" class="no-underline cursor-pointer">{{ items[2].value.label }}</a>
      </div>
    </div>
    }
  </div>
</div>
